module.exports = require('./helpers/bundle-url').getBundleURL('2NEu2') + "logo-dark.eefe0b7f.svg";